module.exports = __webpack_public_path__ + "img/voice_no.59ee7bd5.svg";